export const ROUTES = {
  PARTNERS: '/partners',
  CLIENTS: '/clients',
  CLIENT_DETAIL: '/clients/:uuid',
  ANALYTICS: '/analytics',
  AUTH_PHONE: '/auth/phone',
  AUTH_CODE: '/auth/code',
  NOT_FOUND: '/404',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RouteValue = (typeof ROUTES)[RouteKey];
